import { render, staticRenderFns } from "./ranking-item.vue?vue&type=template&id=2faded76&"
import script from "./ranking-item.vue?vue&type=script&lang=ts&"
export * from "./ranking-item.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/survey-library/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2faded76')) {
      api.createRecord('2faded76', component.options)
    } else {
      api.reload('2faded76', component.options)
    }
    module.hot.accept("./ranking-item.vue?vue&type=template&id=2faded76&", function () {
      api.rerender('2faded76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vue/ranking/ranking-item.vue"
export default component.exports